import { Box, Divider, Grid, IconButton, Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./orderFileModal.css";
import { getIcon } from "utils/iconsConfig";
import ImageModal from "components/ui/ImageModal";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import { usePermissions } from "context/PermissionsContext";
function OrdersFileModal({ openModal, handleClose, data, orderNum }) {
  // const [openCategories, setOpenCategories] = useState(data.map(() => true))
  const [openCategories, setOpenCategories] = useState(() => (Array.isArray(data) ? data.map(() => true) : []));
  const [images, setImages] = useState(() => data.flatMap((obj) => obj.imageFile));
  const [currentIndex, setCurrentIndex] = useState(null);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [currentSelected, setCurrentSelected] = useState(null);
  const permission = usePermissions();
  // const hasAccessToSeeWatermark = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Other Settings", permission), "Watermark"), "view");
  const hasAccessToSeeWatermark = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Watermark"), "view") && !permission?.isAdmin;;

  const isFirstItem = currentIndex === 0;
  const isLastItem = currentIndex === images?.length - 1 || images?.length === 0;

  const fecthDesignCatgeory = (styleNumber) => {
    let category = data.find((entry) => entry.imageFile.some((Obj) => Obj.styleNumber === styleNumber));
    return category ? category.categoryName : null;
  };

  const handleToggle = (idx) => {
    setOpenCategories((prev) => prev.map((open, i) => (i === idx ? !open : open)));
  };

  const handleDownLoadFile = (url, filename) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename || "file");
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  const handleOpenImageModal = (fileData, category) => {
    setOpenImageModal(true);
    let newIndex = images?.findIndex((item) => item?.styleNumber == fileData.styleNumber);
    setCurrentIndex(newIndex);
    setCurrentSelected({ ...fileData, category });
  };

  const handleCloseImageModal = () => {
    setOpenImageModal(false);
    setCurrentIndex(currentIndex);
  };

  const handleNextClick = () => {
    if (currentIndex < images?.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      const nextItem = images[newIndex];
      let category = fecthDesignCatgeory(nextItem.styleNumber);
      setCurrentSelected({ ...nextItem, category });
    }
  };

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      const prevItem = images[newIndex];
      let category = fecthDesignCatgeory(prevItem.styleNumber);
      setCurrentSelected({ ...prevItem, category });
    }
  };

  return (
    <>
      <Modal open={openModal} onClose={handleClose} sx={{ display: "flex", justifyContent: "center", alignItems: "center", border: "none" }}>
        <div style={{ padding: "0rem", height: "640px", width: "80%", background: "#141414", border: "none !important", borderRadius: "8px" }}>
          <Box className="file-header">
            <Typography className="fileName">{`${orderNum} (File)`}</Typography>
            <IconButton disableRipple onClick={handleClose} sx={{ padding: "0px" }}>
              {getIcon("BoxCrossIcon")}
            </IconButton>
          </Box>

          <Divider sx={{ margin: "0rem 1.5rem !important", marginTop: "0rem !important" }} />

          <Box sx={{ marginTop: "1rem", display: "flex", flexDirection: "column", gap: "10px" }}>
            {data.map((Obj, Idx) => (
              <React.Fragment key={Idx}>
                <Box className="catgeory-section-header" onClick={() => handleToggle(Idx)}>
                  <IconButton
                    disableRipple
                    sx={{
                      transform: openCategories[Idx] ? "rotate(0deg)" : "rotate(-90deg)",
                      transition: "transform 0.3s ease",
                      padding: "0px",
                    }}
                  >
                    {getIcon("DownArrow")}
                  </IconButton>
                  <Typography className="catgeoryName">
                    {Obj?.categoryName} - {Obj?.imageFile?.length}
                  </Typography>
                </Box>

                {openCategories[Idx] && (
                  <Grid container sx={{ width: "100%", gap: "1.09vw", paddingLeft: "1.5vw", paddingRight: "1.5vw", display: "flex", alignItems: "center" }}>
                    {Obj.imageFile.map((file, idx) => (
                      <Grid item key={idx} sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "auto", cursor: "pointer" }}>
                        <Box sx={{ position: "relative", display: "flex" }}>
                          <img className="img-file" src={file.url} alt={`file-${idx}`} width="100" style={{ borderRadius: "4px" }} onClick={() => handleOpenImageModal(file, Obj.categoryName)} />

                          <Box
                            sx={{
                              position: "absolute",
                              top: 4,
                              right: 4,
                              backgroundColor: "none !important",
                              borderRadius: "50%",
                              padding: "2px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleDownLoadFile(file.url, `image-${idx + 1}`)}
                          >
                            {getIcon("DownloadIcon")}
                          </Box>

                          <Box
                            sx={{
                              position: "absolute",
                              bottom: 0,
                              left: "50%",
                              transform: "translateX(-50%)",
                              backgroundColor: "rgba(0,0,0,0.5)", // transparent black bg
                              color: "#fff",
                              fontSize: "14px",
                              padding: "4px 10px",
                              borderBottomRightRadius: "4px",
                              borderBottomLeftRadius: "4px",
                              fontWeight: "600",
                              fontFamily: "poppins",
                              width: "100%",
                            }}
                          >
                            {file.styleNumber}
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                )}

                <Divider sx={{ height: "0.3vw !important", background: "#262626", border: "none", marginTop: openCategories[Idx] ? "1rem" : "0rem" }} />
              </React.Fragment>
            ))}
          </Box>
        </div>
      </Modal>
      {openImageModal && (
        <ImageModal
          open={openImageModal}
          handleClose={handleCloseImageModal}
          data={currentSelected}
          hasAccessToSeeWatermark={hasAccessToSeeWatermark}
          hasNext={!isLastItem}
          hasPrev={!isFirstItem}
          nextClick={handleNextClick}
          prevClick={handlePrevClick}
        />
      )}
    </>
  );
}

export default OrdersFileModal;
